(function() {
  'use strict';

  angular.module('component.emailLogs', []);
})();
